var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkbox_tick"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container",
    x: 3.99609,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    fill: "#333399"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M10.9961 16.4L6.99609 12.4L8.39609 11L10.9961 13.6L17.5961 7L18.9961 8.4L10.9961 16.4Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxTick);
export default __webpack_public_path__ + "static/media/Checkbox_tick.dcc48485a28f4e3b326ac40149e3803d.svg";
export { ForwardRef as ReactComponent };